import React from "react";
import {useLocation, useNavigate} from 'react-router-dom';

import styles from "./CheckoutHub.module.scss";

import withRequestHandler from "../../HOC/withRequestHandler";
import ButtonMain from "../../components/buttons/ButtonMain/ButtonMain";

const CheckoutHub = ({ config, makeRequest, isLoading, windowSize }) => {
	const navigate = useNavigate();
	const { state } = useLocation();

	return (
		<div className={styles.wrapper}>
			<div className={styles.title}>{config.checkout}</div>
			<iframe src={state.url} className={styles.wrapperPayment}/>
			<div className={styles.backToShop}>
				<ButtonMain
					text={config.backToShop}
					onClick={() => navigate('/shop')}
					isSmall={windowSize.isMobileView ? true : null}
					isBig={true}
				/>
			</div>
		</div>
	);
};

export default withRequestHandler(CheckoutHub);